import React from 'react';
import {Component} from 'react';
import { Link } from 'gatsby';
import '../style/showcase.scss';
import Layout from '../components/layout'
import '../components/header';
import Header from '../components/header';
import Footer from '../components/footer';
import background from '../images/stretch.jpg'
import stairs from '../images/stretch.jpg'
import a from '../images/1.jpg'
import b from '../images/4.jpg'
import c from '../images/3.jpg'
import d from '../images/5.jpg'
import Showcase from '../components/showcase';
import Accordion from '../components/accordion';

class Crossfit extends Component {
  render() {

    let data = [
    	{
        title: "Do I have to be a CrossFit Deliverance member?", 
        content: `No! All Accelerator Seminars can be stand alone programs open to non-members that focus on getting anyone closer to their goal faster. Members get early access to registration and a discount.`
      }, {
        title: "Is every Accelerator the same?", 
        content: `No! Each will specialize and have a focus in either Powerlifts, Olympic Lifts, Gymnastics, Aerobic Capacity or Nutrition to name a few. Some will be stand alone, but others will be series which will build on each other.`
      },{
        title: "I don’t see a date listed for the Accelerator that I want?", 
        content: `Email us and let us know which one you want! Some Accelerators are always offered while others we wait till there's enough of a demand. So let us know which one you want!`
      }
    ];

    return(
  <>
    <Header color='#707070'/>
    <Showcase background={background} name='ACCELERATOR COURSES' />

    <section id="about" className="container py-5 my-5">
        <div className="row">
            <div className="col">
                <img src={stairs} className="img-responsive left-column-img"/>
                <h2 className="teko my-4">ACCELERATORS</h2> 
                <p className="secondary">Accelerator Courses are a great way to improve your abilities in specific movements in a group setting faster then in a normal CrossFit class. All courses are 4-12 weeks long and meet 1-3 days a week. Expect home work and to work hard.</p>
                <br/>
                <h2 className="teko my-5">COMMON QUESTIONS</h2>
                <Accordion data={data} />
            </div> 
            </div> 
    </section>
    <Footer />
  </>
);
}
}

export default Crossfit
